import { render } from "./Scanner.vue?vue&type=template&id=674b05b8&scoped=true"
import script from "./Scanner.vue?vue&type=script&lang=js"
export * from "./Scanner.vue?vue&type=script&lang=js"

import "./Scanner.vue?vue&type=style&index=0&id=674b05b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674b05b8"]])

export default __exports__